import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { TrainingMethod } from './components/TrainingMethod';
import { ContentSection } from './components/ContentSection';
import { ImaginateSection } from './components/ImaginateSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { UrgencySection } from './components/UrgencySection';
import { PurchaseSection } from './components/PurchaseSection';
import { FinalCTA } from './components/FinalCTA';
import { NotForYouSection } from './components/NotForYouSection';
import { ExtraBonusSection } from './components/ExtraBonusSection';
import { FAQSection } from './components/FAQSection';
import { PurchasePopup } from './components/PurchasePopup';
const HERO_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/vXo5dMLUDpCXX5hUd2FB5U/ChatGPT_Image_Apr_27__2026__08_34_01_PM-removebg-preview.png';
export function App() {
  useEffect(() => {
    if (!(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '1252242806993118');
      f.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-[#1a2e1a] text-[#faf5e8] selection:bg-[#faf5e8] selection:text-[#1a2e1a]" data-id="element-0">
      <HeroSection imageUrl={HERO_IMAGE_URL} data-id="element-1" />
      <TrainingMethod data-id="element-2" />
      <ContentSection data-id="element-3" />
      <ImaginateSection data-id="element-4" />
      <NotForYouSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <ExtraBonusSection data-id="element-8" />
      <PurchaseSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <PurchasePopup data-id="element-12" />
    </div>;
}